import CustomerCommand from './customerCommand';
import DashboardCommand from './dashboardCommand';
import NotificationCommand from './notificationCommand';
import UserCommand from './userCommand';
import WorkingTimeCommand from './workingTimeCommand';
import DateRangeExportCommand from './DateRangeExportCommand';

const Command = {
    User: UserCommand,
    Customer: CustomerCommand,
    Dashboard: DashboardCommand,
    WorkingTime: WorkingTimeCommand,
    Notification: NotificationCommand,
    DateRangeExport: DateRangeExportCommand,
};

export default Command;
